export default __webpack_public_path__ + "static/case-5-42b8145a9faeb13a59ba10553025a3fa.png";